// Shared terminal page states. Convention: every routed page renders exactly
// one of loading / empty / error / content — never a blank div or a
// headers-only table. The pageState testids are the contract the ui-cli UX
// gates race against after navigation, so keep them on the outermost element.
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton, SpecraEmptyState, SpecraInlineBanner } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { Inbox } from 'lucide-react';
export function EmptyState({ icon: Icon = Inbox, title, description, action }) {
    return /*#__PURE__*/ _jsx(SpecraEmptyState, {
        framed: true,
        "data-testid": Testids.pageState.empty,
        icon: /*#__PURE__*/ _jsx(Icon, {
            className: "h-5 w-5",
            "aria-hidden": true
        }),
        title: title,
        description: description,
        action: action
    });
}
export function ErrorState({ error, title = 'Something went wrong', onRetry }) {
    const message = error instanceof Error ? error.message : typeof error === 'string' ? error : undefined;
    return(// tone="danger" renders role="alert" — the same accessibility contract
    // the destructive Alert carried before the Specra swap.
    /*#__PURE__*/ _jsxs(SpecraInlineBanner, {
        tone: "danger",
        variant: "framed",
        "data-testid": Testids.pageState.error,
        action: onRetry && /*#__PURE__*/ _jsx(SpecraButton, {
            variant: "outline",
            size: "sm",
            onClick: onRetry,
            "data-testid": Testids.deliveryShared.errorRetry,
            children: "Retry"
        }),
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "font-medium text-foreground",
                children: title
            }),
            message && /*#__PURE__*/ _jsx("span", {
                className: "ml-2 break-words",
                children: message
            })
        ]
    }));
}
